import React, { useState } from 'react';
import LomavisCard1 from '../../../generic/cards/LomavisCard1/LomavisCard1';
import LomavisButtonToggle1 from '../../../generic/buttons/LomavisButtonToggle1';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import { setApprovalConfiguration } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import {
  STEP_MODE_MULTI_STEP,
  STEP_MODE_SINGLE_STEP
} from '../../../../redux/slices/LomavisPostApproval/constants';

const ApprovalFlowCard: React.FC = () => {
  const dispatch = useDispatch();
  const {
    featuresEnabled,
    data: { step_mode }
  } = useSelector((state: any) => state.lomavisPostApproval);
  const onFlowChange = (value: string) => {
    dispatch(setApprovalConfiguration({ key: 'step_mode', value }));
  };

  const { t } = useTranslate();

  return (
    <LomavisCard1
      title={t('lomavisPostApproval.approvalFlow.title')}
      helpText={t('lomavisPostApproval.approvalFlow.helpText')}
    >
      <LomavisButtonToggle1
        buttonLeftFaIconClass="fa-duotone fa-solid fa-check-circle"
        buttonLeftText={t('lomavisPostApproval.approvalFlow.singleStep')}
        buttonLeftValue={STEP_MODE_SINGLE_STEP}
        buttonLeftShowUpgrade={false}
        buttonRightFaIconClass="fa-duotone fa-solid fa-tasks"
        buttonRightText={t('lomavisPostApproval.approvalFlow.multiStep')}
        buttonRightValue={STEP_MODE_MULTI_STEP}
        buttonRightShowUpgrade={!featuresEnabled.approvalProcessMultistep}
        value={step_mode}
        onChange={onFlowChange}
      />
    </LomavisCard1>
  );
};

export default ApprovalFlowCard;
